import { Trans } from '@lingui/macro';
import { Button } from '@pocketlaw/tetris';
import { useApproval } from 'app/domains/approval';
export function SendReminderButton() {
    const { cancellingRequest } = useApproval();
    return (<Button appearance="secondary" $stretch disabled={cancellingRequest || true}>
      <Trans comment="Approval drawer - send reminder - button label">Send reminder</Trans>
    </Button>);
}
